import { render, staticRenderFns } from "./PapercleanConfigurazioneCategorieListComponent.vue?vue&type=template&id=03300411"
import script from "./PapercleanConfigurazioneCategorieListComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneCategorieListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports